export default __webpack_public_path__ + "static/up-0ee72a86b545ac55b57da32273df5055.svg";